import React from 'react';
import PropTypes from 'prop-types';

function ShopExpireAlertBanners({
  nearCount,
  nearCountAll,
  nearCountPro,
  expiredCount,
  onViewNearAll,
  onViewNearPro,
  onViewExpired,
}) {
  const showNear = nearCount > 0;
  const showExpired = expiredCount > 0;
  if (!showNear && !showExpired) return null;

  return (
    <div className='expire-alert-banners'>
      {showNear ? (
        <div className='expire-alert-banner expire-alert-banner--near' role='alert'>
          <div className='expire-alert-banner__body'>
            <i className='fas fa-exclamation-triangle' aria-hidden='true' />
            <div className='expire-alert-banner__text'>
              <span className='expire-alert-banner__title'>
                พบสินค้าใกล้หมดอายุ {nearCount} รายการ
              </span>
              <span className='expire-alert-banner__sub'>
                กรุณาตรวจสอบและดำเนินการก่อนถึงวันหมดอายุ
              </span>
            </div>
          </div>
          <div className='expire-alert-banner__links'>
            {nearCountAll > 0 ? (
              <button type='button' className='expire-alert-banner__link' onClick={onViewNearAll}>
                ดูรายการ ราคาปกติ ({nearCountAll}) →
              </button>
            ) : null}
            {nearCountPro > 0 ? (
              <button type='button' className='expire-alert-banner__link' onClick={onViewNearPro}>
                ดูรายการ ลดราคา ({nearCountPro}) →
              </button>
            ) : null}
          </div>
        </div>
      ) : null}
      {showExpired ? (
        <div className='expire-alert-banner expire-alert-banner--expired' role='alert'>
          <div className='expire-alert-banner__body'>
            <i className='fas fa-exclamation-triangle' aria-hidden='true' />
            <div className='expire-alert-banner__text'>
              <span className='expire-alert-banner__title'>
                พบสินค้าหมดอายุ {expiredCount} รายการ
              </span>
              <span className='expire-alert-banner__sub'>
                ระบบซ่อนสินค้าจากผู้ซื้อแล้ว โปรดนำสินค้าออกจากร้าน
              </span>
            </div>
          </div>
          <button type='button' className='expire-alert-banner__link' onClick={onViewExpired}>
            ดูรายการ →
          </button>
        </div>
      ) : null}
    </div>
  );
}

ShopExpireAlertBanners.propTypes = {
  nearCount: PropTypes.number.isRequired,
  nearCountAll: PropTypes.number.isRequired,
  nearCountPro: PropTypes.number.isRequired,
  expiredCount: PropTypes.number.isRequired,
  onViewNearAll: PropTypes.func.isRequired,
  onViewNearPro: PropTypes.func.isRequired,
  onViewExpired: PropTypes.func.isRequired,
};

export default ShopExpireAlertBanners;
